module.exports = __webpack_public_path__ + "img/441162583.e62cbe33.jpg";